// Timeline.tsx
import { Box } from '@mui/material';
import { ReactNode } from 'react';

// Define the Timeline props interface
interface TimelineProps {
  children: ReactNode;
  paddingLeft?: string | number;
}

// Define the TimelineItem props interface
interface TimelineItemProps {
  children: ReactNode;
  dotSize?: number;
  dotColor?: string;
  borderColor?: string;
  borderSize?: number;
}

export function Timeline({ children, paddingLeft = '20px' }: TimelineProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        margin: '100px auto',
        paddingLeft,
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        my: '10px',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      {children}
    </Box>
  );
}

export function TimelineItem({
  children,
  dotSize = 24,
  dotColor = '#2F736E',
  borderColor = 'rgb(161, 209, 205)',
  borderSize = 5,
}: TimelineItemProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        '&:not(:last-child)::after': {
          content: '""',
          position: 'absolute',
          width: 0,
          height: 'calc(100% + 20px)',
          borderLeft: '1px dashed #2F736E',
          top: `calc(1rem + ${dotSize}px)`, // Start after the dot
          left: '-20px',
          zIndex: 0,
        },
      }}
    >
      {/* The dot indicator for each timeline item */}
      <Box
        sx={{
          content: '""',
          position: 'absolute',
          height: `${dotSize}px`,
          width: `${dotSize}px`,
          backgroundColor: dotColor,
          top: '1rem',
          left: '-32px',
          borderRadius: '50%',
          zIndex: 1,
          border: `${borderSize}px solid ${borderColor}`,
        }}
      />

      {children}
    </Box>
  );
}

export function TimelineBody({ children }: { children: ReactNode }) {
  return <Box sx={{ color: 'text.secondary' }}>{children}</Box>;
}
